export const DEFAULT_PRICING_VERSION = "v2";

/** URL param that holds the open/closed state of the switch-to-yearly dialog. */
export const SWITCH_PLAN_MODAL_PARAM = "upgrade-interval";

/**
 * The customer's state the day before an invoice, computed by the analytics
 * model (not Stripe). Empty when the model has no value for that day.
 */
export const PREVIOUS_DAY_STATUS = {
  DIRECT_CONVERSION: "direct conversion",
  ACTIVE_TRIAL_CONVERSION: "active trial conversion",
  EXPIRED_TRIAL_CONVERSION: "expired trial conversion",
  ACTIVE_PAID: "active paid",
  REACTIVATION: "reactivation",
} as const;

/** Unbroken monthly renewals the yearly ledger needs, and the most it counts. */
export const PAID_RUN_WINDOW = { minMonths: 3, maxMonths: 8 } as const;

/** How long the ledger must stay in view to count as an impression (IAB's 1s). */
export const LEDGER_MIN_VISIBLE_MS = 1000;

/** Savings, in major units, the yearly ledger must beat to be worth pitching. */
export const MIN_LEDGER_SAVINGS = 14;

/** Renewals only, so each invoice is one month: no proration or one-off invoices. */
export const RENEWAL_BILLING_REASONS = [
  "subscription_create",
  "subscription_cycle",
] as const;
